import {JobAssignmentSubmissionResult} from "./JobAssignmentEventHandler";
import {JobAssignmentUpdate} from "../../generated/graphql";
import {getArrayFromField} from "../General";
import {Constants} from "../../constants/constants";

export type PendingAssignment = {
  jobIds: number[];
  jobStopIds: number[];
  manifestDriverId: number;
  user: string;
  assignmentDateTime: number;
  status: JobAssignmentSubmissionResult;
  updatedAt: number;
};

export const findAssignmentFromUpdatePredicate = (assignment: PendingAssignment, update: JobAssignmentUpdate) => {
  const jobIdsMatch =
    getArrayFromField(assignment.jobIds).length > 0 &&
    getArrayFromField(assignment.jobIds).includes(getArrayFromField(update.jobIds)[0]);
  const jobStopIdsMatch =
    getArrayFromField(assignment.jobStopIds).length > 0 &&
    getArrayFromField(assignment.jobStopIds).includes(getArrayFromField(update.jobStopIds)[0]);
  const manifestMatch = !assignment.manifestDriverId || assignment.manifestDriverId === update.manifestDriverId;

  return manifestMatch && (jobIdsMatch || jobStopIdsMatch);
};

export const findAssignmentFromUpdate = (
  assignments: PendingAssignment[],
  update: JobAssignmentUpdate
): PendingAssignment | undefined => {
  return assignments
    .filter((x) => x.status !== JobAssignmentSubmissionResult.ASSIGNMENT_SUCCESS)
    .find((x) => findAssignmentFromUpdatePredicate(x, update));
};

export const createAssignmentFromUpdate = (update: JobAssignmentUpdate): PendingAssignment => {
  return {
    jobIds: update.jobIds as number[],
    jobStopIds: update.jobStopIds as number[],
    manifestDriverId: update.manifestDriverId as number,
    user: update.userName as string,
    assignmentDateTime: Date.now(),
    status: JobAssignmentSubmissionResult.PENDING,
    updatedAt: Date.now()
  };
};

export const activePendingActions = (
  assignments: PendingAssignment[],
  hideWhenAssignmentSuccess?: boolean
): PendingAssignment[] => {
  const statuses = [JobAssignmentSubmissionResult.PENDING, JobAssignmentSubmissionResult.SUBMISSION_SUCCESS];

  if (hideWhenAssignmentSuccess) {
    return assignments?.filter(
      (pa) =>
        statuses.includes(pa.status) ||
        (JobAssignmentSubmissionResult.ASSIGNMENT_SUCCESS &&
          Date.now() - pa.updatedAt < Constants.GENERAL_POLLING_INTERVAL)
    );
  }

  return assignments?.filter((pa) => statuses.includes(pa.status));
};

export const pendingActionsByManifestDriverId = (manifestDriverId: number, pendingActions: PendingAssignment[]) => {
  return activePendingActions(pendingActions)?.filter((action) => action.manifestDriverId === manifestDriverId);
};
